import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownList(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownList',
    baseStyle: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      position: 'absolute',
      width: '100%',
      border: `1px solid ${theme.colors.black23}`,
      maxHeight: '150px',
      overflowY: 'auto',
      zIndex: 100,
      scrollbarWidth: 'initial',
      borderRadius: theme.sizes['-3'],
      backgroundColor: theme.colors.background,

      ['&::-webkit-scrollbar']: {
        display: 'auto'
      }
    }
  };
}
